import { Badge } from "@/components/ui/Badge";
import { Card } from "@/components/ui/Card";
import { StatCard } from "@/components/ui/StatCard";
import {
  calculatePowerScore,
  getCharacterSubtitle,
  getCharacterTitle,
} from "@/features/characters/character-utils";
import { attributeLabels } from "@/features/characters/defaults";
import { formatDateTime } from "@/lib/format";
import type { Character } from "@/features/characters/types";

interface CharacterSummaryProps {
  character: Character;
}

export function CharacterSummary({ character }: CharacterSummaryProps) {
  return (
    <div className="grid gap-6 xl:grid-cols-[1.1fr_0.9fr]">
      <Card
        title={getCharacterTitle(character)}
        subtitle={getCharacterSubtitle(character)}
        action={<Badge tone="gold">Pontuação {calculatePowerScore(character)}</Badge>}
      >
        <div className="space-y-6">
          <p className="text-sm leading-7 text-mist">
            {character.summary || "Sem resumo narrativo preenchido."}
          </p>
          <div className="grid gap-4 sm:grid-cols-2">
            <div className="rounded-3xl border border-gold/15 bg-black/15 p-4">
              <p className="text-xs uppercase tracking-[0.24em] text-mist">Objetivos</p>
              <p className="mt-3 whitespace-pre-wrap text-sm leading-7 text-parchment/90">
                {character.goals || "Nenhum objetivo registrado."}
              </p>
            </div>
            <div className="rounded-3xl border border-gold/15 bg-black/15 p-4">
              <p className="text-xs uppercase tracking-[0.24em] text-mist">Equipamentos</p>
              <p className="mt-3 whitespace-pre-wrap text-sm leading-7 text-parchment/90">
                {character.equipment || "Nenhum equipamento registrado."}
              </p>
            </div>
          </div>
          <div className="grid gap-3 text-sm text-mist sm:grid-cols-2">
            <p>Criado em {formatDateTime(character.createdAt)}</p>
            <p>Atualizado em {formatDateTime(character.updatedAt)}</p>
          </div>
        </div>
      </Card>

      <div className="grid gap-4 sm:grid-cols-2">
        {attributeLabels.map((attribute) => (
          <StatCard
            key={attribute}
            label={attribute}
            value={character.attributes[attribute]}
            detail="Atributo base"
          />
        ))}
      </div>
    </div>
  );
}
